import { Outlet } from 'react-router-dom';

import { Footer, Header } from 'components';

const title = 'Michigan Vaccine Provider Resource Online';

export default function RootLayout() {
  return (
    <div className="font-montserrat bg-page-gradient-primary flex min-h-screen flex-col">
      <Header title={title} />
      <div className="flex flex-1 flex-col">
        <Outlet />
      </div>
      <Footer title={title} />
    </div>
  );
}
